module.exports = __webpack_public_path__ + "static/media/DrMundo_0.932f656f.png";